export default __webpack_public_path__ + "static/media/activate-icon.70af9eb2.svg";